<div class="sections">
    <div>
        <div class="files-list">
            <ng-container [ngTemplateOutlet]="fileBox" [ngTemplateOutletContext]="{ name: 'Proof of business', id: 'proofOfBusiness' }"></ng-container>
            <ng-container [ngTemplateOutlet]="fileBox" [ngTemplateOutletContext]="{ name: 'Void check', id: 'voidCheck' }"></ng-container>
            <ng-container [ngTemplateOutlet]="fileBox" [ngTemplateOutletContext]="{ name: 'Previous payment processor (Optional)', id: 'previousPaymentProcessor' }"></ng-container>
        </div>
        <div class="actions">
            <button mat-flat-button color="primary" (click)="nextClick.emit(false)">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
            <h4 *ngIf="progress !== 100" class="simple-text-button skip-button" (click)="nextClick.emit(true)">Skip the documents and add them later</h4>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info" #containerDiv>

            <p>
                <strong>Only legal owners of the business can fill, sign and send this form.</strong><br>
                If you are not one of the legal owners, <span class="simple-text-button" (click)="navigateToTransferOwnership()">click here to transfer the accounts ownership</span>
            </p>

            <div class="note">
                <p>
                    Note: Our platform stores this information solely for the application process.
                    Once it's submitted we send this information to Nuvei and delete it from out system.
                </p>
            </div>

            <p>
                You can skip this step for now and continue filling out the form.
                If you choose to skip, you will have the opportunity to upload these documents at the end before submitting the form.
            </p>

            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let field of fieldExplanations; let i = index" [id]="'nuvei_app_' + field.id">
                <p>{{ field.title }}</p>
                <h4>{{ field.explanation }}</h4>
            </div>
        </div>
    </div>
</div>

<ng-template #fileBox let-name="name" let-id="id">
    <div class="file-wrapper" [id]="'document_'+id"
         (mouseenter)="activeExplanationChange(id, true)"
         (mouseleave)="activeExplanationChange(id, false)"
    >
        <h4>{{ name }}</h4>
        <div class="file-box" [class.error]="missingDocuments.includes(id) || errors[id] === 'missing'" appDragNDrop (fileDropped)="addFile(id, $event)">
            <input type="file" #input style="display: none" (change)="addFile(id, $any($event.target).files?.item(0) ?? null)">
            <div class="upload-info">
                <app-icon src="upload"></app-icon>
                <div class="text">
                    <p>Drag & Drop or<br>a file to upload</p>
                    <p>JPG, GIF or PNG files</p>
                </div>
            </div>
            <button mat-flat-button color="primary" (click)="input.click()">{{ !!(errors[id] ?? uploadedFiles[id]) ? 'Replace' : 'Choose' }} File</button>
        </div>
        <div class="file-data" *ngIf="(errors[id] ?? uploadedFiles[id]); let file; else missingError">
            <div class="d-flex align-items-center flex-fill" style="gap: 12px">
                <ng-container [ngTemplateOutlet]="fileImg" [ngTemplateOutletContext]="{ text: fileExt(file.mimeType) }"></ng-container>
                <div class="file-info flex-fill">
                    <h4>{{ file.name }}</h4>
                    <small *ngIf="!uploadingFiles[id]" [class.error]="errors[id]">
                        <span *ngIf="!errors[id]">{{ fileSize(file.size) }}. {{ file.ts | date: 'dd MMM, YYYY'}}</span>
                        <span *ngIf="errors[id]">{{ errors[id].message }}</span>
                    </small>
                    <div class="progress-bar" *ngIf="uploadingFiles[id]">
                        <div class="progress-bar-value"></div>
                    </div>
                </div>
            </div>
            <app-icon class="se-icon-button" src="trash" *ngIf="!uploadingFiles[id]" (click)="removeFile(id); input.value=$any(null)"></app-icon>
        </div>
        <ng-template #missingError>
            <div class="file-data" *ngIf="missingDocuments.includes(id)">
                <div class="file-info">
                    <small class="error">{{ missingDocumentErrorForId[id] }}</small>
                </div>
            </div>
        </ng-template>
    </div>
</ng-template>

<ng-template #fileImg let-text="text">
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_402_2599)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z" fill="#E9F0FA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0V4H22L18 0Z" fill="#C2CDDE"/>
        </g>
        <rect x="1" y="10" width="22" height="10" rx="1" fill="#4881F1"/>
        <text x="12" y="17.5" fill="white" text-anchor="middle" font-family="Arial" font-size="6" font-weight="bold">{{text}}</text>
        <defs>
            <clipPath id="clip0_402_2599">
                <rect width="20" height="24" fill="white" transform="translate(2)"/>
            </clipPath>
        </defs>
    </svg>
</ng-template>
